import React from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Typography, Menu, MenuItem, IconButton, Box, Card, CardContent, Avatar } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { indigo } from '@mui/material/colors';

const companies = [
  { id: 3, name: "Mayaland", location: "Mayaland Atlanta", color: "#1565c0", logo: "https://mayaland-src.s3.us-east-2.amazonaws.com/logo_mayaland.png" },
  { id: 6, name: "Altitude", location: "Altitude Atlanta", color: "#212121", logo: "https://mayaland-src.s3.us-east-2.amazonaws.com/ALT1.png" },
];

const SelectCompany = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const companyDashboard = (company) => {
    navigate(`/dashboard/${company.id}`);
  }

  return (
    <Box sx={{ flexGrow: 1, height: "100vh", backgroundColor: "#f4f6f8" }}>
      {/* Navbar */}
      <AppBar position="static" color="default" elevation={1} style={{ backgroundColor: '#3f51b5' }}>
        <Toolbar>
          <Typography variant="p" sx={{ flexGrow: 1, color: indigo[100] }}>
            Portal Manager
          </Typography>
          
          <IconButton onClick={handleMenuOpen} color="inherit">
            <Avatar sx={{ bgcolor: indigo[300] }}>
              <AccountCircleIcon />
            </Avatar>
            <Typography variant="p" style={{ fontSize: '0.8rem', marginLeft: 4, color: indigo[100] }}>User</Typography>
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Contenido Principal */}
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="80vh">
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          Please select your company to proceed.
        </Typography>

        <Box display="flex" gap={4} mt={4}>
          {companies.map((company) => (
            <Card key={company.name} onClick={() => companyDashboard(company)} sx={{ width: '50%', textAlign: "center", backgroundColor: company.color, color: "#fff", cursor: "pointer", transition: "0.3s", "&:hover": { opacity: 0.9 } }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{height: 100}}>
                  <img src={company.logo} alt="" style={{width: '80%', maxHeight: 85}} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {company.name}
                </Typography>
                <Typography variant="body2">{company.location}</Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SelectCompany;
